import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api, { fileUrl } from "../lib/api";
import { useLang } from "../context/LanguageContext";

export const NewsDetail = () => {
  const { id } = useParams();
  const { t, pick } = useLang();
  const [n, setN] = useState(null);

  useEffect(() => { api.get(`/news/${id}`).then((r) => setN(r.data)).catch(() => {}); }, [id]);

  if (!n) return <div className="mx-auto max-w-3xl px-5 py-20 text-muted-foreground">Loading…</div>;
  const fmt = (d) => new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });

  return (
    <article className="mx-auto max-w-3xl px-5 py-14">
      <Link to="/news" className="inline-flex items-center gap-1 text-sm font-bold text-brand-greendark hover:underline">
        <ArrowLeft className="h-4 w-4" /> {t("back")}
      </Link>
      <span className="mt-6 block text-xs font-bold uppercase tracking-widest text-brand-greendark">{fmt(n.created_at)}</span>
      <h1 className="mt-2 font-display text-4xl font-black tracking-tight sm:text-5xl">{pick(n, "title")}</h1>
      {n.image_path && (
        <img src={fileUrl(n.image_path)} alt={pick(n, "title")} className="mt-6 aspect-[16/9] w-full rounded-3xl border-2 border-brand-ink object-cover" />
      )}
      <div className="prose prose-lg mt-8 max-w-none whitespace-pre-wrap text-lg leading-relaxed text-brand-ink/90">
        {pick(n, "content")}
      </div>
    </article>
  );
};

export default NewsDetail;
